//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"DisplayPosition",1,0],[0,"DisplayThicknessDirection",1,0],[0,"ExtendedTicBegin",1,0],[0,"ExtendedTicColor",1,0],[0,"ExtendedTicFont",1,0],[0,"ExtendedTicFrequency",1,0],[0,"ExtendedTicLength",1,0],[0,"ExtendedTicWidth",1,0],[0,"LabelColor",1,0],[0,"LabelFont",1,0],[0,"LabelItalicized",1,0],[0,"LabelName",1,0],[0,"LabelTextAspectRatio",1,0],[0,"LabelTextFontGapFactor",1,0],[0,"LabelTextHeight",1,0],[0,"LabelTextLetteringAngle",1,0],[0,"LabelWidth",1,0],[0,"NumberOfStartFrame",1,0],[0,"SkipLabelBegin",1,0],[0,"SkipLabelFrequency",1,0],[0,"SkipTicBegin",1,0],[0,"SkipTicFrequency",1,0],[0,"TicColor",1,0],[0,"TicDisplay",1,0],[0,"TicFont",1,0],[0,"TicLabelTextOrientation",1,0],[0,"TicLength",1,0],[0,"TicWidth",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.FrameBarElementStyleBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.FrameBarElementStyleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.FrameBarElementStyleBuilder.LabelTextOrientation = Object.freeze({
    "AlongTic" : "AlongTic", "PerpendicularToTic" : "PerpendicularToTic"});

export default SPLM;